module.exports = __webpack_public_path__ + "static/media/iconM2.7f6b51b1.svg";